@import "../../globalStyles/commons";

:host {
  display: block;
  --progress-height: .5rem;
  .spinner {
    line-height: 0;
  }
}

@keyframes progress-bar-indeterminate {
  0% {
    background-position-x: 25%
  }

  80%,to {
    background-position-x: -105%
  }
}

.progress {

  .progress-header {
    display: flex;
    align-items: center;
    .progress-label {
      flex: 1;
    }
  }

  .progress-track {
    height: var(--progress-height);
    width: 100%;
    background: var(--border-subtle-00);
    position: relative;
    margin: var(--spacing-03) 0;

    .progress-bar {
      height: 100%;
      background: var(--border-interactive);
      transition: width .3s ease-in-out;
    }


  }

  .progress-helper {
    @include font-style(helper-text-01);
  }



  &.indeterminate {
    .progress-track {
      .progress-bar {
        display: none;
      }
      &:after {
        animation-duration: 1.4s;
        animation-iteration-count: infinite;
        animation-name: progress-bar-indeterminate;
        animation-timing-function: linear;
        background-image: linear-gradient(90deg,var(--cds-interactive,#0f62fe) 12.5%,transparent 12.5%);
        background-position-x: 0;
        background-size: 200% 100%;
        content: "";
        inset: 0;
        position: absolute
      }
    }
  }

  &.status-success {
    .progress-bar {
      background: var(--support-success);
    }
    .progress-icon {
      --icon-color: var(--support-success);
    }
  }

  &.status-error {
    .progress-bar {
      background: var(--support-error);
    }
    .progress-icon {
      --icon-color: var(--support-error);
    }
  }

}

:host([size="sm"]) {
  --progress-height: 0.25rem;
}


